import { Font } from '@react-pdf/renderer';
import React, { PropsWithChildren } from 'react';

const FontProvider: React.FC<PropsWithChildren<{ locale: string }>> = ({ locale, children }) => {
    let bold = '/fonts/SourceSansPro-Bold.ttf';
    let regular = '/fonts/SourceSansPro-Regular.ttf';
    if (['ko-KR', 'ko'].includes(locale)) {
        regular = '/fonts/NanumGothic-Regular.ttf';
        bold = '/fonts/NanumGothic-Bold.ttf';
    }

    Font.register({
        family: 'Regular',
        src: regular,
    });

    Font.register({
        family: 'Bold',
        src: bold,
    });

    return <>{children}</>;
};

export default FontProvider;
